interface ScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md';
}

export default function ScoreBadge({ score, size = 'sm' }: ScoreBadgeProps) {
  const sizeClass = size === 'md' ? 'text-sm px-2.5 py-1' : 'text-xs px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 font-semibold text-background-50 whitespace-nowrap ${sizeClass}`}
    >
      <i className="ri-star-fill text-[0.7em]"></i>
      {score.toFixed(1)}
    </span>
  );
}